import React from 'react';
import loadable from '@loadable/component';
import { sharedConstants } from 'shared-helpers';

import { CLIENT_LOGOS } from '/src/lib/constants/logoConstants.js';
import { CONTACT_FORM_TYPE } from '/src/lib/constants';

const ContactForm  = loadable(() => 
    import(/* webpackChunkName: "Contact" */ '/src/components/ContactForms/ContactForm')
);



const TAXONOMIES = sharedConstants.TAXONOMIES;

export const FormSection = (props) => {

    const { pageProps } = props;
    const { dataType }  = pageProps;

    const isRegionPage  = (pageProps.type === 'region');
    const isInvestmentTypePage = (pageProps.type === 'investment_type');

    const getFormTitle = () => {
        let title = '';
        if (isRegionPage) {
            title = `Use MAGNiTT to invest smarter and lead in ${dataType}'s fast-moving markets`;
        } else if (isInvestmentTypePage) {
            let text = dataType.split('Investment')[0];
            title = `Use MAGNiTT to invest smarter and lead in fast-moving ${text} markets`;
        }
        return title;
    }

    return (
        <div className="pricing-contact-form" id="contactForm">
            <div className="row">

                <div className="col-md-10 col-lg-7 col-xl-7 mx-auto mb-4 mb-lg-0">
                    <div className="db-box no-background h-100">
                        <div className="text-section">
                            <div className="pricing-clients">
                                <div className="row">

                                    <p className="pricing-form-header text-center">
                                        Our data is trusted by
                                        <span>the world's leading companies</span>
                                    </p>

                                    {CLIENT_LOGOS.map((logo, i) => {
                                        return (
                                            <div className="col-6 col-md-4 col-lg-5" key={"logo-" + i}>
                                                <div className="img-container">
                                                    <img className="img-fluid" src={logo} />
                                                </div>
                                            </div>
                                        )
                                    })}
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
                <ContactForm
                    taxonomyType={TAXONOMIES.salesContactOptions}
                    formType={CONTACT_FORM_TYPE.enterprise}
                    buttonLabel='Book a discovery call'
                    page={pageProps.hubspotFormSource}
                    headerText={
                        <p className="pricing-form-header">
                            <span className="mb-2">Interested in learning more?</span>
                            {getFormTitle()}
                        </p>
                    }
                />

            </div>
        </div>
    )

}